module.exports = __webpack_public_path__ + "no-avatar.0dd4f472dc6600cfcc66.svg";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/images/no-avatar.svg
// module id = ../../../../../src/assets/images/no-avatar.svg
// module chunks = styles